import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from 'src/app/shared/contexts/asyncData';

import { getMiscContentDetailsPageData } from './api';
import type { MiscContentDetailsPageDataErrorCode } from './types';

export const {
	Context: MiscContentDetailsPageDataContext,
	Provider: MiscContentDetailsPageDataContextProvider,
	useContext: useMiscContentDetailsPageData,
	useAsyncData: useMiscContentDetailsPageDataFromApi,
	prefetchAsyncData: prefetchMiscContentDetailsPageDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'MiscContentDetailsPageDataContext',
	dataProperty: 'pageData',
	getData: getMiscContentDetailsPageData,
	hookDeps: ({ countryCode, locale, slug }) => [countryCode, locale, slug],
	getUniqueId: ({ countryCode, locale, slug }) => [countryCode, locale, slug].join('|'),
	errorHandler: pageDataErrorHandler<MiscContentDetailsPageDataErrorCode>(),
});
